import {useOutletContext} from 'extensions/navigation';
import type {WorkspaceContext} from '../../layout/LayoutWorkspace';

export function useWorkspaceContext() {
  return useOutletContext<WorkspaceContext>() ?? ({} as WorkspaceContext);
}
